// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1XN4X","right":"Footer_right__3Q1M1","buttons":"Footer_buttons__3tbI1"};